"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.muiFormControlStyles = void 0;
exports.muiFormControlStyles = {
    defaultProps: {
        size: 'small',
    },
};
//# sourceMappingURL=form-control.js.map